import DataLoader from "dataloader";
import { POLL_TYPE } from "./../../ricos-content/index.js";
import { PollsService } from "./PollsService.js";
const isSSR = () => typeof window === "undefined";
const getMembersModulePromise = () => {
  return import(
    /* webpackChunkName: "wix-ricos-members" */
    "@wix/members"
  ).then(
    (module) => module.members
  );
};
const fetchMembers = (membersIds, getWixClientPromise) => Promise.all([getWixClientPromise(), getMembersModulePromise()]).then(
  ([wixClient, members]) => wixClient.use(members).queryMembers().in("_id", membersIds).find().then((res) => res.items).catch((e) => {
    console.error("[pollsStrategy] fetchMembers failed. error:", e);
    return [];
  }).then(normalizeMembers)
);
const membersCache = /* @__PURE__ */ new Map();
function createMembersLoader(loadMembers) {
  return new DataLoader(
    (memberIds) => {
      return loadMembers(memberIds).then(
        (memberList) => memberIds.map(
          (id) => memberList.find((m) => m.siteMemberId === id) || new Error("Member not found")
        )
      );
    },
    { cacheMap: membersCache }
  );
}
const normalizeMembers = (rawMembers) => rawMembers?.map?.((member) => {
  return {
    siteMemberId: member._id ?? void 0,
    imageUrl: member.profile?.photo?.url ?? void 0,
    name: {
      nick: member.profile?.nickname ?? void 0
    }
  };
});
function pollsStrategy(instance, getWixClientPromise) {
  if (!instance) {
    return {};
  }
  const getSiteMembers = isSSR() ? void 0 : (() => {
    const loader = createMembersLoader(async (memberIds) => {
      const members = await fetchMembers(memberIds, getWixClientPromise);
      return memberIds.map(
        (id) => members.find((m) => m.siteMemberId === id) || {
          // We fallback to private member if member not found, or we have fetch error for now.
          siteMemberId: id
        }
      );
    });
    return loader.loadMany.bind(loader);
  })();
  return {
    config: {
      [POLL_TYPE]: {
        pollServiceApi: new PollsService(getWixClientPromise),
        siteToken: instance,
        getSiteMembers
      }
    }
  };
}
export {
  pollsStrategy as default
};
//# sourceMappingURL=pollsStrategy.js.map
